import { createSlice } from "@reduxjs/toolkit";

import OrderTransfer from "../../../../../services/OrderTransfer";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<
	State,
	OrderTransfer.SendAvailable[]
> = (state, action) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateSendAvailableData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.SEND_AVAILABLE,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateSendAvailableDataAction =
	globalStateSendAvailableData.actions;
export const globalStateSendAvailableDataReducer =
	globalStateSendAvailableData.reducer;
export type globalStateSendAvailableDataState = State;

export default globalStateSendAvailableData;
